import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import ManivelleCasse from "./components/ManivelleCasse";
import Mecanisme from "./components/Mecanisme";
import Reglage from "./components/Reglage";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function ManivelleVoletRoulant() {
  return (
    <main>
      <SEOHead
        title="Manivelle Volet Roulant Strasbourg | Remplacement"
        description="Remplacement et réparation de manivelle de volet roulant à Strasbourg et dans le Bas-Rhin. Toutes marques, devis gratuit. 03 74 47 32 40."
        path="/manivelle-volet-roulant"
        type="service"
        serviceType="Remplacement de manivelle de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Manivelle volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Manivelle volet roulant" }]} />
      <Hero />
      <DiagnosticVideo />
      <Reassurances />
      <ManivelleCasse />
      <Mecanisme />
      <Reglage />
      <ReparerPlutot />
      <CTAAppel />
      <FAQ />
      <Galerie />
      <Maillage />
      <Formulaire />
      <CTAAppel />
      <Avis />
      <Footer />
      <FloatingButton />
    </main>
  );
}